import { useEffect } from 'react';
import { Button, Col, Form, Input, Row, Typography } from 'antd';
import { useLogin } from "./hooks/HookLogin";
import { useParams } from 'react-router-dom';

const onFinishFailed = errorInfo => {
    //console.log('Failed:', errorInfo);
};


const PassResetForm = () => {
    const [form] = Form.useForm();
    const { token } = useParams();

    const { onValidateToken, onRecoveryPass } = useLogin();

    useEffect(() => {
        if (!token) return;
        onValidateToken(token);
    }, []);

    const onFinish = async (values) => {
        const data = { "token": token, "new_password": values?.new_password };
        await onRecoveryPass(data);
    };


    return (
        <Form
            name="passwordReset"
            form={form}
            style={{ maxWidth: 600 }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="vertical"
        >
            <Row align="middle" justify="center">
                <Col span={20} style={{ marginBottom: '20px', marginTop: '20px' }}>
                    <Typography.Text strong>Por favor, ingrese su nueva contraseña para restablecer su cuenta.</Typography.Text>
                </Col>
                <Col span={20}>

                    <Form.Item
                        label="Nueva Contraseña"
                        name="password"
                        rules={[
                            { required: true, message: '¡Por favor ingresa una nueva contraseña!' },
                            { min: 8, max: 20, message: 'La contraseña debe tener entre 8 y 20 caracteres' },
                            {
                                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
                                message: 'La contraseña debe contener al menos una letra minúscula, una letra mayúscula y un número'
                            },
                        ]}
                    >
                        <Input.Password placeholder="Nueva contraseña" />
                    </Form.Item>
                </Col>
                <Col span={20}>
                    <Form.Item
                        label="Confirmar Contraseña"
                        name="new_password"
                        dependencies={['password']}  // Añadir dependencia para comparar con la contraseña original
                        rules={[
                            { required: true, message: '¡Por favor confirma tu nueva contraseña!' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('¡Las contraseñas no coinciden!'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password placeholder="Confirmar contraseña" />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Cambiar Contraseña
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
};
export default PassResetForm;